module.exports = __webpack_public_path__ + "static/media/ipsum_brand.eb27e03c.png";